import { WebsitesApiFactory, V1Website } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { Website } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'

function createWebsites(rawWebsites?: V1Website[]): Website[] {
  if (!rawWebsites) return [] as Website[]

  return rawWebsites.map((w: V1Website): Website => {
    return new Website({
      id: w.id,
      displayName: w.displayName,
      url: w.url,
      passcode: w.passcode,
      useTenantIdPass: w.useTenantIdPass,
    })
  })
}

export const NewWebsitesApiFunc = () => {
  const webAdapter = WebsitesApiFactory(undefined, api.defaults.baseURL, api)

  return {
    listWebsites: async (companyId: string, filter?: string, page?: number): Promise<ApiResponse<ListResponse<Website>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.listWebsites(companyId, filter, page)
        data = createWebsites(res.data.websites)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as Website[]
        err = e
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    },

    getWebsite: async (companyId: string, websiteId: string): Promise<ApiResponse<Website | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.getWebsite(companyId, websiteId)
        data = createWebsites([res.data])[0]
      } catch (e) {
        err = e
      }

      return {
        data,
        err,
      }
    },

    createWebsite: async (companyId: string, website: Website): Promise<ApiResponse<Website | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.createWebsite(companyId, { data: website })
        data = createWebsites([res.data])[0]
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    updateWebsite: async (companyId: string, websiteId: string, website: Website): Promise<ApiResponse<Website | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.updateWebsite(companyId, websiteId, { data: website })
        data = createWebsites([res.data])[0]
      } catch (e) {
        err = e
      }

      return {
        data,
        err,
      }
    },

    deleteWebsite: async (companyId: string, websiteId: string): Promise<ApiResponse<void>> => {
      let data, err

      try {
        await webAdapter.deleteWebsite(companyId, websiteId)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    }
  }
}